import { cookie } from '@playcastdotio/Cookie';
import { createPlayerPersistentId } from '@playcastdotio/CreateId';
import { bandwidthClient, pingClient } from '@playcastdotio/PingClient';
import { networkMetricsState } from './stores/globalStores';
import { sendMessage } from './modules/realtimeMessaging';
import { NotificationMessageType, websocket } from '@playcastdotio/Messaging';

// Store anonymous ID in memory for tab lifetime only
let anonymousPlayerId: string | null = null;
export const getPersistentPlayerId = () => {
  const searchParams = new URLSearchParams(window.location.search);

  // Check for anonymous mode first
  if (searchParams.has('anon')) {
    const anonParam = searchParams.get('anon');

    // If anon has a value (anon=<id>), use that ID
    if (anonParam && anonParam !== '') {
      anonymousPlayerId = anonParam;
      return anonymousPlayerId;
    }

    // Otherwise, create a new anonymous ID if we don't have one
    if (!anonymousPlayerId) {
      anonymousPlayerId = createPlayerPersistentId();
    }
    return anonymousPlayerId;
  }

  const { get, set } = cookie();
  const cookieId = get('playcast-player-id');
  const localStorageId = localStorage.getItem('playcast-player-id');
  
  // Take first valid ID found
  const id = cookieId || localStorageId;
  
  if (id && !id?.startsWith('player_')) {
    // remake the id
    const newId = createPlayerPersistentId();
    set('playcast-player-id', newId);
    localStorage.setItem('playcast-player-id', newId);
    return newId;
  }
  
  if (id) {
    // Repair missing storage to maintain redundancy
    if (!cookieId) {
      set('playcast-player-id', id);
      console.log('[PersistentId] Restored cookie from localStorage:', id);
    }
    if (!localStorageId) {
      localStorage.setItem('playcast-player-id', id);
      console.log('[PersistentId] Restored localStorage from cookie:', id);
    }
    return id;
  }
  const playerId = searchParams.get('id');
  if (playerId) {
    set('playcast-player-id', playerId);
    localStorage.setItem('playcast-player-id', playerId);
    return playerId;
  } else {
    const newId = createPlayerPersistentId();
    set('playcast-player-id', newId);
    localStorage.setItem('playcast-player-id', newId);
    return newId;
  }
};

// const handlePingResults = (results) => {
//   console.log('[IPC-Fns] Ping results', results);
//   networkMetricsState.updateState({
//     ...networkMetricsState.currentState,
//     ping: results,
//   });
// };

// pingClient.initialize(10 * 1000, handlePingResults);
// pingClient.start();
